export const FETCH_SETTINGS = 'settings/FETCH_SETTINGS';
export const FETCH_SETTINGS_SUCCESS = 'settings/FETCH_SETTINGS_SUCCESS';